import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';
import { jackpotValues, mainGoldFont } from '../../fontStyles';

export default class ControllerJackpotPanels extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    this.timeouts = [];
    this.init();
    this.setTextStile();
    this.updatePanels();
    this.addListeners()
  }

  init() {
    this.panels = [];
    this.grandPanel = this.getChildByName('grand');
    this.panels.push(this.grandPanel);
    this.grandPanelAmount = this.grandPanel.getChildByName('textAmount');
    this.grandPanelTitle = this.grandPanel.getChildByName('jackpot_panels_0');
    this.megaPanel = this.getChildByName('mega');
    this.panels.push(this.megaPanel);
    this.megaPanelAmount = this.megaPanel.getChildByName('textAmount');
    this.megaPanelTitle = this.megaPanel.getChildByName('jackpot_panels_1');
    this.majorPanel = this.getChildByName('major');
    this.panels.push(this.majorPanel);
    this.majorPanelAmount = this.majorPanel.getChildByName('textAmount');
    this.majorPanelTitle = this.majorPanel.getChildByName('jackpot_panels_2');
    this.startAnimations();
  }

  addListeners() {
    GlobalDispatcher.add('model:betChanged', this.updatePanels, this);
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onResize,
      this
    );
  }

  onResize(data) {
    if (data.isLandscape) {
      this.goToFrame(1)
      this.init();
      this.panels.forEach(panel => panel.goToFrame(1));
      this.setTextStile();
      this.updatePanels();
    } else if (data.isMobile && data.isPortrait) {
      this.goToFrame(2);
      this.init();
      this.panels.forEach(panel => panel.goToFrame(2));
      this.setTextStile();
      this.updatePanels();
    }
  }

  setTextStile() {
    this.grandPanelTitle.style = { ...this.grandPanelTitle.style, ...mainGoldFont };
    this.grandPanelAmount.style = { ...this.grandPanelAmount.style, ...jackpotValues };
    this.megaPanelTitle.style = { ...this.megaPanelTitle.style, ...mainGoldFont };
    this.megaPanelAmount.style = { ...this.megaPanelAmount.style, ...jackpotValues };
    this.majorPanelTitle.style = { ...this.majorPanelTitle.style, ...mainGoldFont };
    this.majorPanelAmount.style = { ...this.majorPanelAmount.style, ...jackpotValues };
  }

  updatePanels() {
    const decimals = EntryPoint.GameModel.currencyInfo.decimals;
    this.grandPanelAmount.text = MoneyFormat.formatCurrency(EntryPoint.GameModel.jackpotList[2], decimals);
    this.megaPanelAmount.text = MoneyFormat.formatCurrency(EntryPoint.GameModel.jackpotList[1], decimals);
    this.majorPanelAmount.text = MoneyFormat.formatCurrency(EntryPoint.GameModel.jackpotList[0], decimals);
  }

  startAnimations() {
    const offset = 500;
    this.clearTimeouts();
    const timeout = setInterval(() => {
      this.panels.forEach((panel, index) => {
        const timeout = setTimeout(() => {
          panel.startAnimation();
        }, index * offset)
        this.timeouts.push(timeout)
      })
    }, 24000);
    this.timeouts.push(timeout)
  }

  clearTimeouts() {
    this.timeouts.forEach(timeout => clearTimeout(timeout))
    this.timeouts = [];
  }

  destroy() {
    this.clearTimeouts();
    super.destroy({ children: true })
  }
}
